import React, { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import Skeleton from '@shared/v2/components/Skeleton';

import Button from '@/components/Button';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import dataLayer from '@/v2/utils/dataLayer';

export type CTAButtonProps = Omit<
  ComponentProps<typeof Button>,
  'children' | 'onClick'
> & {
  text: string;
  onClick?: () => void;
};
const StyledButton = styled(Button)`
  &:disabled {
    background: ${themeGet('colors.white')};
    border-color: ${themeGet('colors.greys.dusty')};
    color: ${themeGet('colors.greys.dusty')};
  }
`;

const CTAButton = ({ text, onClick, ...props }: CTAButtonProps) => {
  const shouldUseNewEvents = useGA4Events();

  const onCtaClick = () => {
    if (shouldUseNewEvents) {
      dataLayer.ctaClickEvent({
        itemText: text,
      });
    }
    onClick?.();
  };

  return (
    <Skeleton mt="4" width="100%" height="48px">
      <StyledButton
        py="10px"
        px="8"
        variant="primary"
        mt="4"
        width="100%"
        // @ts-expect-error outline is valid but not inferred correctly
        outline
        onClick={onCtaClick}
        {...props}
      >
        <Text fontWeight="bold" display="block" lineHeight="1.5" fontSize="sm">
          {text}
        </Text>
      </StyledButton>
    </Skeleton>
  );
};

export default CTAButton;
